import React from 'react';
import {Drawer} from 'antd';

import Comments from '../Comments';
import {TicketCommentsDrawerProps} from '../../../types/ticketTypes';

const TicketCommentsDrawer = ({ticket, drawerOpen, handleClose}: TicketCommentsDrawerProps) => {
    const mobileMode = window.innerWidth <= 768;
    const drawerWidth = mobileMode ? "100%" : "45%";

    const resetDrawer = React.useCallback(() => {
        handleClose();
    }, [handleClose]);

    return (
        <Drawer
            title={`Comments - Ticket #${ticket.ticket_number}`}
            width={drawerWidth}
            open={drawerOpen}
            onClose={resetDrawer}
            forceRender={true}
        >
            <Comments
                commentableType='App\Models\System\Ticket'
                commentableID={ticket.id}
            />
        </Drawer>
    );
}

export default TicketCommentsDrawer;
